"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import smoothscroll from "smoothscroll-polyfill";
import "pace-progressbar";

gsap.registerPlugin(EaselPlugin, ScrollTrigger);

function breakPace() {
  Pace.stop();
}

setTimeout(breakPace, 2000);

Pace.on("done", function () {
  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
        duration: 0.65,
      },
    })
    // .to(".loading", { opacity: 0, zIndex: -100 })
    .add("scene01")
    .to(".top-kv__img--01 .top-kv__item", { opacity: 1, y: 0 }, "scene01 +=0.5")
    .to(".top-kv__img--02 .top-kv__item", { opacity: 1, y: 0 }, "scene01 +=0.5")
    .add("scene02")
    .to(".top-kv__img--04 .top-kv__item", { opacity: 1, x: 0 }, "scene02")
    .to(".top-kv__img--06 .top-kv__item", { opacity: 1, x: 0 }, "scene02")
    .add("scene03")
    .to(".top-kv__img--03 .top-kv__item", { opacity: 1, x: 0 }, "scene03")
    .to(".top-kv__img--07 .top-kv__item", { opacity: 1, y: 0 }, "scene03")
    .to(".top-kv__img--08 .top-kv__item", { opacity: 1, y: 0 }, "scene03")
    .to(".top-kv__img--09 .top-kv__item", { opacity: 1, x: 0 }, "scene03")

    .to(".top-kv__img--13 .top-kv__item", { opacity: 1, y: 0 }, "scene03")

    .to(".top-kv__img--11 .top-kv__item", { opacity: 1, x: 0 }, "scene03")
    .to(".top-kv__img--12 .top-kv__item", { opacity: 1, y: 0 }, "scene03")
    .to(".top-kv__img--15 .top-kv__item", { opacity: 1, y: 0 }, "scene03 -=0.3")
    .to(".top-kv__img--10 .top-kv__item", { opacity: 1, y: 0 }, "scene03 -=0.3")
    .to(".top-kv__img--14 .top-kv__item", { opacity: 1, y: 0 }, "scene03 -=0.3")
    .to(".top-kv__img--16 .top-kv__item", { opacity: 1, y: 0 }, "scene03 -=0.3")
    .to(
      ".top-kv__img--05 .top-kv__item",
      { opacity: 1, y: 0, x: 0 },
      "scene04 -=0.2"
    )
    .to(
      ".top-kv__ttl",
      { opacity: 1, yPercent: -10, duration: 1 },
      "scene04 +=0.4"
    )
    .to(".top-kv-news", { opacity: 1, yPercent: -100 }, "scene04 +=0");
});

let chochin = ".top-kv__img--10";
let chochinLight = ".top-kv-chochin__light";
let chochinTxt = ".top-kv-chochin__txt";
document.querySelector(chochin).addEventListener("click", (e) => {
  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
        duration: 0.2,
      },
    })
    .to(chochin, { rotate: -10, y: -5 })
    .to(chochin, { rotate: 10, y: -10 })
    .to(chochin, { rotate: -10, y: -15 })
    .to(chochin, { rotate: 10, y: -20 })
    .to(chochin, { rotate: -10, y: -20 })
    .to(chochin, { rotate: -10, y: -20 })
    .to(chochin, { rotate: 10, y: -15 })
    .to(chochin, { rotate: -10, y: -5 })
    .to(chochin, { rotate: 10, y: 0 })
    .to(chochin, { rotate: -10, y: 0 });

  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
        duration: 0.2,
      },
    })
    .to(chochinLight, { opacity: 1, duration: 1 })
    .to(chochinLight, { opacity: 0, duration: 1 }, "+=1");
  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
        duration: 0.2,
      },
    })
    .to(chochinTxt, { opacity: 1, duration: 1 })
    .to(chochinTxt, { opacity: 0, duration: 1 }, "+=1");
});

let sakura = ".top-kv-sakura";
let sakuraTree = ".top-kv-sakura__tree";
let sakuraLeaf = ".top-kv-sakura__flower";
let sakuraBg = ".top-kv-sakura__bg";
document.querySelector(sakura).addEventListener("click", (e) => {
  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
        duration: 0.2,
      },
    })
    .to(sakuraTree, {
      opacity: 1,
      duration: 0.6,
    })
    .to(sakuraBg, {
      opacity: 0,
      duration: 0.6,
    })
    .to(sakuraLeaf, {
      opacity: 1,
      duration: 0.6,
    })
    .to(sakuraLeaf, {
      rotate: 360,
      duration: 2,
    })
    .add("scene01")
    .to(
      sakuraLeaf,
      {
        opacity: 0,
        duration: 0.6,
      },
      "scene01 -=0.3"
    )
    .to(sakuraBg, {
      opacity: 1,
      duration: 0.6,
    })
    .to(sakuraTree, {
      opacity: 0,
      duration: 0.6,
    })
    .to(sakuraLeaf, {
      rotate: 0,
      duration: 0,
    });
});

let mikoshi = ".top-kv-mikoshi";
let mikoshiMain = ".top-kv-mikoshi__main";
let mikoshiPerson = ".top-kv-mikoshi__person";
document.querySelector(mikoshi).addEventListener("click", (e) => {
  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
        duration: 0.4,
      },
    })
    .to(mikoshi, {
      rotate: -10,
      y: -10,
    })
    .to(mikoshi, {
      rotate: 10,
      y: -15,
    })
    .to(mikoshi, {
      rotate: -10,
      y: -20,
    })
    .to(mikoshi, {
      rotate: 10,
      y: -15,
    })
    .to(mikoshi, {
      rotate: 0,
      y: 0,
    });
  gsap
    .timeline({
      defaults: {
        ease: "power2.out",
        duration: 0.4,
      },
    })
    .to(mikoshiPerson, {
      rotate: 8,
      y: -10,
      opacity: 1,
    })

    .to(mikoshiPerson, {
      rotate: -8,
      y: 0,
    })

    .to(mikoshiPerson, {
      rotate: 8,
      y: -10,
    })

    .to(mikoshiPerson, {
      rotate: -8,
      y: 0,
    })
    .to(mikoshiPerson, {
      rotate: 0,
      y: 0,
      opacity: 0,
    });
});

function toggleClassWithScroll(target, selector, className) {
  let elements = document.querySelectorAll(selector);
  let targets = document.querySelectorAll(target);

  Array.prototype.forEach.call(elements, function (element, index) {
    // windowの高さ - a
    let windowHeight = window.document.documentElement.clientHeight;

    // 現在のスクロール量
    let scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;

    // 画面左上から要素までの高さ - b
    let rect = element.getBoundingClientRect();
    let offset = rect.top + scrollTop;

    // 要素が画面に表示されるスクロール量(a - b)
    let scrollHeight = offset - windowHeight;

    // 画面の1/4を超えたら、classを追加
    if (scrollTop > scrollHeight + windowHeight / 4) {
      targets.forEach((target) => {
        target.classList.add(className);
      });
    } else {
      // targets.forEach((target) => {
      //   target.classList.remove(className);
      // });
    }
  });
}

/**
 * スクロールイベント登録
 */
window.addEventListener(
  "scroll",
  function () {
    toggleClassWithScroll(
      ".top-iki-sec--01 .top-iki-anime-obj",
      ".top-iki-sec--01",
      "is-anime"
    );
    toggleClassWithScroll(
      ".top-iki-sec--02 .top-iki-anime-obj",
      ".top-iki-sec--02",
      "is-anime"
    );
    toggleClassWithScroll(
      ".top-iki-sec--03 .top-iki-anime-obj",
      ".top-iki-sec--03",
      "is-anime"
    );
    toggleClassWithScroll(".top-iki-anime-obj", ".top-iki-last", "is-anime");
    toggleClassWithScroll(".top-sp01 .anime-obj", ".top-sp01", "is-anime");
    toggleClassWithScroll(".top-sp02 .anime-obj", ".top-sp02", "is-anime");
    toggleClassWithScroll(".top-movie .anime-obj", ".top-movie", "is-anime");
    toggleClassWithScroll(".top-movie__bg", ".top-movie__bg", "is-anime");
    toggleClassWithScroll(
      ".top-person__ttl .anime-obj",
      ".top-person__ttl",
      "is-anime"
    );
    toggleClassWithScroll(
      ".top-person__in .anime-obj",
      ".top-person__in",
      "is-anime"
    );
    toggleClassWithScroll(
      ".top-company__main",
      ".top-company__main",
      "is-anime"
    );
    toggleClassWithScroll(
      ".top-company__sub .anime-obj",
      ".top-company__sub",
      "is-anime"
    );
    toggleClassWithScroll(".top-company__bg", ".top-company__bg", "is-anime");
    toggleClassWithScroll(
      ".top-synergy .anime-obj",
      ".top-synergy",
      "is-anime"
    );
  },
  false
);

const swiper = new Swiper(".swiper-container", {
  loop: true,
  autoplay: {
    delay: 8000,
  },
});

// const topVideo = document.getElementById("compay-movie");

// function playVideo() {
//   topVideo.play();
// }
// topVideo.addEventListener("click", (e) => {
//   playVideo();
// });
